import mainLogo from '../../images/Umuarama/logo-umuarama_pecas.png';
import squareLogo from '../../images/Umuarama/umuaramaLogo_square_black.png';
import squareLogoWhite from '../../images/Umuarama/umuaramaLogo_square_white.png';
import bannerLogoWhite from '../../images/Umuarama/logo-umuarama_pecas_branco.png';
import banner01 from '../../images/Umuarama/umuarama_mainBanner_bg_5.jpg';
import banner02 from '../../images/Umuarama/umuarama_mainBanner_bg_3.jpg';
import banner03 from '../../images/Umuarama/umuarama_mainBanner_bg_4.jpg';
import bannerImg01 from '../../images/Umuarama/logo-umuarama_pecas_branco.png';
import bannerAboutUs from '../../images/Umuarama/umuarama_mainBanner_bg_2.jpg';
import bannerSpecial1 from '../../images/Umuarama/diadospais_01.png';
import bannerSpecial2 from '../../images/Umuarama/diadospais_01_mobile.png';
import car123 from '../../images/Umuarama/123_jetta.jpg';
import box123 from '../../images/Umuarama/123_umuarama.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Umuarama',
    defaultStoreLink: 'loja.grupoumuarama.com.br',
    defaultContactEmail: 'ecommerce@grupoumuarama.com.br',
    whatsappNumber: '62 99936 2311',
    CNPJname: 'Umuarama Administracao e Participacao Concessionaria LTDA',
    CNPJ: '26.481.915/0001-50',
    CNPJaddress: 'Rua Tamboril, n. 91, Qd. 127, R. L-3, Setor - Santa Genoveva, Goiânia - GO, 74672-540',
    launchDate: '07/09/2024',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "citroen",
        "fiat",
        "kia",
        "peugeot",
        "toyota",
        "volkswagen",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "UMUARAMA TOYOTA ARAGUAINA",
        "UMUARAMA TOYOTA IMPERATRIZ",
        "UMUARAMA TOYOTA RIO VERDE",
        "UMUARAMA VW ITUMBIARA",
        "UMUARAMA VW ARAGUAINA",
        "UMUARAMA FIAT PARAUAPEBAS",
        "UMUARAMA FIAT REDENCAO",
        "UMUARAMA FIAT ARAGUAINA",
        "UMUARAMA KIA",
        "UMUARAMA CITROEN RIO VERDE",
        "UMUARAMA TOYOTA CALDAS NOVAS",
        "UMUARAMA TOYOTA MINEIROS",
        "UMUARAMA TOYOTA ITUMBIARA",
        'UMUARAMA HARLEY GOIANIA',
        'UMUARAMA VW CATALAO',
        "UMUARAMA KTM GOIANIA",
        "UMUARAMA TOYOTA BACABAL",
    ],
    
    disabledSellers: [
        "UMUARAMA VW PALMAS",
        "UMUARAMA TOYOTA BALSAS",
        "UMUARAMA HARLEY UBERLANDIA",
        "TRIUMPH UBERLANDIA - UMUARAMA",
    ],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            50: 2,
            200: 3,
            300: 4,
            500: 5,
            1200: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,
    
    bannerImg01: bannerImg01,
    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: '',
    bannerBrands: banner02,
    aboutUsBg: bannerAboutUs,
    car123: car123,
    box123: box123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: bannerSpecial1,
    bannerSpecialMobile: bannerSpecial2,

    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças <span style="font-weight: bold;">originais</span> compatíveis com seu veículo, direto das concessionárias <span style="font-weight: bold;">Umuarama</span>.',
    aboutUs: {
        title: 'Grupo Umuarama',
        content: [
            'Foi em meados da década de 1970, que o jovem Luiz Pereira Martins Pires, nascido no interior do Maranhão, iniciou a construção do Grupo Umuarama. O nome Umuarama, que em tupiguarani significa “lugar onde os amigos se encontram”, foi herdado da primeira fazenda da família, no Estado do Pará. O Grupo Umuarama, hoje composto por 3 unidades de negócios – agropecuária, empreendimentos imobiliários e concessionárias -, atua nos estados de Minas Gerais, Goiás, Pará, Maranhão e Tocantins.',
        ],
        link: 'https://umuaramaconcessionarias.com.br/quem-somos/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/umuaramaconcessionarias/',
        Facebook: 'https://www.facebook.com/umuaramaconcessionariasoficial/',
        LinkedIn: 'https://www.linkedin.com/company/umuarama/?originalSubdomain=br',
        Youtube: 'https://www.youtube.com/channel/UC3876ox5JFQPFM7zOXbZcQg',
        Twitter: '',
    },

    footerContent: [],
}